/**
 * Pace input/output utilities.
 *
 * Contract (spec 02-profile-api.md §페이스 입력 형식 계약):
 *  - API pace fields are integer seconds.
 *  - Frontend converts "MM:SS/km" ↔ seconds before sending / after receiving.
 *  - Backend rejects string paces; Zod range (600–28800) is final validator.
 */

const PACE_INPUT_PATTERN = /^(\d{1,2}):(\d{2})\/km$/;

export function parsePaceInput(input: string): number | null {
  const match = input.trim().match(PACE_INPUT_PATTERN);
  if (!match) return null;
  const mm = parseInt(match[1], 10);
  const ss = parseInt(match[2], 10);
  if (ss >= 60) return null;
  return mm * 60 + ss;
}

export function formatPaceSec(sec: number): string {
  const mm = Math.floor(sec / 60);
  const ss = sec % 60;
  return `${mm}:${String(ss).padStart(2, "0")}/km`;
}
